<template>
  <div>
    <div>
      <el-form :model="form" ref="form" label-width="120px" :hide-required-asterisk="true">
        <div @keyup.enter.stop="save()">
          <el-form-item label="考级须知" prop="examineeName">
            <el-input v-model="form.examineeName" :maxlength="20" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="考级指南" prop="examineeIdNo">
            <el-input v-model="form.examineeIdNo" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="确认考级曲目" prop="examinee">
            <el-input v-model="form.examinee" placeholder=""></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  name: "exam-result-task-edit",
  components: {},
  props: ['row'],
  data () {
    return {
      form: {}
    }
  },
  async created () {
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {

  },
  computed: {},
  watch: {},
  methods: {
    async initForm () {
      if (this.row) {
        let info = JSON.parse(JSON.stringify(this.row))
        this.form = info
      }
      this.$nextTick(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      })
    }
  }
};
</script>
